/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Team-group admin list, editor, analysis, and two-panel item page.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {AdminResourcePagesModule} from '../../common/controller/admin-resource-pages.module';
import {TeamGroupEditPageComponent} from './team-group-edit-page.component';
import {TeamGroupItemPageComponent} from './team-group-item-page.component';
import {TeamGroupListPageComponent} from './team-group-list-page.component';
import {TeamGroupAnalysisPageComponent} from './team-group-analysis-page.component';
import {TeamGroupRoutePageComponent} from './team-group-route-page.component';

const TEAM_GROUP = [
  TeamGroupEditPageComponent,
  TeamGroupItemPageComponent,
  TeamGroupListPageComponent,
  TeamGroupAnalysisPageComponent,
  TeamGroupRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    AdminListModule,
    AdminResourcePagesModule
  ],
  declarations: TEAM_GROUP,
  exports: TEAM_GROUP
})
export class TeamGroupModule {
}
